import {
    DataSourceMode, TableRowBeforeSaveEvent, TableRowCreationEvent, TableRowDisplayEvent, TableRowMode, Textbox
} from "@mcleod/components";
import { AutogenLayoutTableProfile } from "./autogen/AutogenLayoutTableProfile";
import { ModelRow, UserSettings } from "@mcleod/core";
import { LMEUserSettings } from "./settings/LMEUserSettings";

export class TableProfile extends AutogenLayoutTableProfile {
    private _driverName: string;
    private _parentRowType: string;

    getComponentById: any;

    get driverName(): string {
        return this._driverName;
    }

    set driverName(value: string) {
        this._driverName = value;
    }

    get parentRowType(): string {
        return this._parentRowType;
    }

    set parentRowType(value: string) {
        this._parentRowType = value;
    }

    /** This is an event handler for the beforeRowSave event of tableCallRecords. */
    tableCallRecordsBeforeRowSave(event: TableRowBeforeSaveEvent) {
        const modelRow = event.getTableRow().data as ModelRow;
        modelRow.set("contact_name", this._driverName);
        modelRow.set("parent_row_type", this._parentRowType);
        modelRow.set("caller_user_id", UserSettings.getUserId());
    }

    /** This is an event handler for the onRowDisplay event of tableCallRecords. */
    tableCallRecordsOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        if (tableRow.mode === TableRowMode.QUICK_ADD) {
            const textboxCallerUserId = tableRow.findComponentById("textboxEnteredBy") as Textbox;
            if (textboxCallerUserId) {
                textboxCallerUserId.text = LMEUserSettings.getUserName();
            }
        }
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxCommentTypeId. */
    textboxCommentTypeIdBeforeLookupModelSearch(event) {
        event.filter.is_active = "Y"
    }

    /** This is an event handler for the onRowCreate event of tableCallRecords. */
    tableCallRecordsOnRowCreate(event: TableRowCreationEvent) {
        const parentLayout = this.getParentLayout();
        if (parentLayout?.mainDataSource?.mode !== DataSourceMode.SEARCH) {
            const tableRow = event.getTableRow();
            const modelRow = tableRow?.data as ModelRow;
            if (modelRow._appending) {
                LMEUserSettings.setUserLookupModelData("caller_user_id", modelRow);
            }
        }
    }
}

